"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _VerifyCodeBtn = _interopRequireDefault(require("@/components/VerifyCodeBtn"));

var _wxAuthorize = _interopRequireDefault(require("@/mixins/wx-authorize"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Login',
  mixins: [_wxAuthorize.default],
  components: {
    VerifyCodeBtn: _VerifyCodeBtn.default
  },
  computed: {
    disabled: function disabled() {
      var disabled = true;

      if (this.phone.length == 11) {
        if (this.type === 'password' && this.password.length >= 6) {
          disabled = false;
        } else if (this.password.length === 4) {
          disabled = false;
        }
      }

      return disabled;
    },
    loginWayObj: function loginWayObj() {
      if (this.type === 'password') {
        return {
          icon: 'closed-eye',
          toggleMsg: '验证码登录'
        };
      }

      return {
        icon: 'eye',
        toggleMsg: '密码登录'
      };
    },
    passwordIcon: function passwordIcon() {
      return this.passwordType === 'password' ? 'closed-eye' : 'eye';
    }
  },
  data: function data() {
    return {
      phone: '',
      password: '',
      code: '',
      type: 'password',
      passwordType: 'password',
      phoneError: ''
    };
  },
  methods: {
    sendVerifyCode: function sendVerifyCode() {
      this.phoneError = '';

      if (!this.phone) {
        // 根据需求做判断
        this.phoneError = '手机号码必填';
      }
    },
    switchPasswordType: function switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    switchType: function switchType() {
      this.password = this.code = '';
      this.type = this.type === 'password' ? 'verifyCode' : 'password';
    },
    login: function () {
      var _login = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  phone: this.phone,
                  type: this.type
                };

                if (this.type === 'verifyCode') {
                  data['captcha'] = this.password;
                } else {
                  data['password'] = this.password;
                }

                that = this;
                _context.next = 5;
                return this.$store.dispatch('user/login', {
                  data: data
                }).then(function (res) {
                  // 获取未登录的时候跳到登录页面的redirect地址
                  var redirect = that.$route.query.redirect;

                  if (redirect) {
                    console.log('存在回跳地址就回跳');
                    console.log(redirect); // 存在回跳地址就回跳

                    // 存在回跳地址就回跳
                    return window.location.replace(redirect);
                  } else {
                    // 否则就跳到默认的首页
                    return that.$router.push({
                      name: 'Index'
                    });
                  }
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function login() {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  },
  created: function created() {
    console.log(this.$route);
    this.wxLogin(this);
  }
};
exports.default = _default;